import React from "react";
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";

import Home from "../Components/pages/Home";
import { Aboutcreativity } from "../Components/pages/Aboutcreativity";
import About from "../Components/pages/About";
import Servicepage from "../Components/pages/Servicepage";
import Portfolio from "../Components/pages/Portfolio";
import Contact from "../Components/pages/Contact";
import Aboutlogics from "../Components/pages/Aboutlogics";
import Aboutleads from "../Components/pages/Aboutleads";
import PrivacyPolicy from "../Components/pages/PrivacyPolicy";
import TermsofUse from "../Components/pages/TermsofUse";

import PortfolioDetails from "../Components/layouts/PortfolioDetails";
import WordpressDownloadPlugin from "../Components/pages/WordpressDownloadPlugin";

/* Blog Components Import */
import BlogList from "../Components/pages/BlogList";


import NotFound from "../Components/pages/NotFound ";
import BlogDetail from "../Components/layouts/BlogDetail";


const router = createBrowserRouter([

    {
        path: "/",
        element: <Home />,
    },

    {
        path: "/About",
        element: <About />,
    },

    {
        path: "/Service",
        element: <Servicepage />,
    },

    {
        path: "/Portfolio",
        element: <Portfolio />,
    },

    {
        path: "/Contact",
        element: <Contact />,
    },

    {
        path: "/creativity",
        element: <Aboutcreativity />,
    },

    {
        path: "/logics",
        element: <Aboutlogics />,
    },

    {
        path: "/leads",
        element: <Aboutleads />,
    },

    {
        path: "/PrivacyPolicy",
        element: <PrivacyPolicy />,
    },

    {
        path: "/TermsofUse",
        element: <TermsofUse />,
    },

    {
        path: "/portfolio-details",
        element: <PortfolioDetails />,
    },

    /* =====================================================
        WORDPRESS DOWNLOAD PLUGIN
       ===================================================== */
    {
        path: "/wordpress-plugin",
        element: <WordpressDownloadPlugin />,
    },

    /* =====================================================
        BLOG ROUTES
       ===================================================== */
    {
        path: "/blogs",
        element: <BlogList />,
    },
    {
        path: "/blog/:id",
        element: <BlogDetail />,
    },

    /* =====================================================
        404
       ===================================================== */

    {
        path: "*",
        element: <NotFound />,
    },

]);


export default function Rout() {
    return <RouterProvider router={router} />;
}